import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export default class OrderProcessingService {
    baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
    constructor(private http: HttpClient) { }

    triggerCoinGeneration(): Observable<any> {
      console.log("Triggering coin generation...");
        return this.http.post(this.baseUrl + `OrderProcessing/trigger`, {});
      }
}
